import React, {useEffect, useState} from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from 'recharts';
import {ChartContainer} from '../styles/Dashboard.style';
import {TableHeader} from 'src/components/header/TableHeader';
import {useAuth} from 'src/modules/auth/hooks/useAuth';
import {HttpAuthService} from 'src/services';
import {routeLink} from 'src/constant';
import {getMonthName} from 'src/utils/commonMethod';
import {useToast} from '@unthinkable/react-toast';

const CustomTooltip = ({active, payload, label}) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload;
    return (
      <div className="bg-white p-3 rounded shadow text-sm">
        <p className="font-semibold">{getMonthName(label)}</p>
        <p>Optimal Revenue: ${data.optimalRevenue.toLocaleString()}</p>
        <p>99495 Billed: ${data.revenue99495.toLocaleString()}</p>
        <p>99496 Billed: ${data.revenue99496.toLocaleString()}</p>
      </div>
    );
  }
  return null;
};

const xTickFormatter = val => {
  const month = getMonthName(val);
  return month;
};
const RevenueChart = () => {
  const {user} = useAuth();
  const [data, setData] = useState([]);
  const toast = useToast();

  const modifiedData = data.map(d => ({
    ...d,
    optimalRevenue: d.eligibleEncounter * 275,
    revenue99495: d['99495BillableEncounter'] * 205,
    revenue99496: d['99496BillableEncounter'] * 275,
    clientRevenuePotential:
      d.eligibleEncounter * 275 -
      (d['99495BillableEncounter'] * 205 + d['99496BillableEncounter'] * 275),
  }));
  const fetchTcmRevenueData = async () => {
    try {
      const response = await HttpAuthService.get(routeLink.tcmRevenue, {
        params: {
          practiceId: user?.practiceId?._id,
        },
      });
      if (!response) return;
      setData(response.data);
    } catch (err) {
      toast({
        type: 'Error',
        message: `${err?.message || err || ''}`,
      });
    }
  };
  useEffect(() => {
    fetchTcmRevenueData();
  }, []);

  return (
    <ChartContainer>
      <TableHeader title={'Missed TCM Revenue'} />
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={modifiedData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="month" tickFormatter={val => xTickFormatter(val)} />
          <YAxis tickFormatter={val => `$${(val / 1000).toFixed(0)}k`} />
          <Tooltip content={<CustomTooltip />} />
          <Legend />
          <Line
            type="monotone"
            dataKey="clientRevenuePotential"
            stroke="#8884d8"
            strokeWidth={3}
            dot={{r: 4}}
          />
        </LineChart>
      </ResponsiveContainer>
    </ChartContainer>
  );
};
export default RevenueChart;
